@if (activity(); as current) {
  @if (current.lastSucceededLabel || current.lastFailedLabel) {
    <div class="process-activity" [class.process-activity--error]="current.hasError">
      @if (current.lastSucceededLabel) {
        <span>{{ 'Last successful run' | translate }}: {{ current.lastSucceededLabel }}</span>
      }
      @if (current.hasError && current.lastFailedLabel) {
        <span>{{ 'Last failed run' | translate }}: {{ current.lastFailedLabel }}</span>
      }
    </div>
  }
}
